import { request, Paginated } from "utils/api";
import { serialize } from "object-to-formdata";
import { Club } from "api/clubs";

// fetch single club (GET /admin/clubs/single)
export const getClub = (data: {
    clubId: string
}) => request<Club>({
    data,
    endpoint: "/admin/clubs/single",
    method: "get",
});

// fetch clubs (GET /admin/clubs)
export const getClubs = (data: {
    limit?: number,
    locationRestrictionType?: "none" | "geo-fence" | "check-in",
    mainSportForm?: string,
    offset?: number,
    query?: string,
    sortKey?: "clubName" | "shortName" | "mainSportForm",
    sortOrder?: "ASC" | "DESC",
}) => request<Paginated<Club>>({
    data,
    endpoint: "/admin/clubs",
    method: "get",
});

// edit clubs (PATCH /admin/clubs)
interface PatchClubsParams {
    addresseeName?: string,
    autoAcceptMembershipRequests?: boolean,
    autoInviteMembersToEvents?: boolean,
    bookingMinDurationMins?: number,
    city?: string,
    clubDescription?: string,
    clubEmail?: string,
    clubIds: string[],
    clubKey?: string,
    clubName?: string,
    clubPhone?: string,
    clubWebsite?: string,
    comingUpBookingMins?: number,
    country?: string,
    geofencingRadiusMeters?: number,
    internalBookingAtomMins?: number,
    isCoronaReady?: boolean,
    latitude?: number,
    locationRestrictionType?: "none" | "geo-fence" | "check-in",
    longitude?: number,
    mainSportForm?: string,
    postalCode?: string,
    prohibitStandardBookings?: boolean,
    restrictAllBookingsToOneHour?: boolean,
    shortName?: string,
    stateOrProvince?: string,
    street?: string,
    timeZone?: string,
}
export const patchClubs = (data: PatchClubsParams) => request<Club[]>({
    data,
    endpoint: "/admin/clubs",
    method: "patch",
});

// generate check-in qr code pdf (POST /admin/clubs/check-in-qrcode)
export const postClubsCheckinQrcode = (data: {
    clubId: string,
    theme?: "dark" | "light",
}) => request<{ url: string }>({
    data,
    endpoint: "/admin/clubs/check-in-qrcode",
    method: "post",
});

// update profile picture (PUT /admin/clubs/logo)
export const uploadClubLogo = (data: {
    clubId: string,
    clubLogo: File,
}) => request<Club>({
    data: serialize(data),
    endpoint: "/admin/clubs/logo",
    method: "post",
});

// remove profile picture (DELETE /admin/clubs/logo)
export const removeClubLogo = (data: {
    clubId: string,
}) => request<Club>({
    data,
    endpoint: "/admin/clubs/logo",
    method: "delete",
});
